import { TPayloadBlock, TPayloadFlow } from './types.ts';
import { FieldType } from '../../types/types.ts';
import { ENVIRONMENTS } from '../../utils/constants.ts';
import { REACT_APP_ENVIRONMENT } from '../../utils/envConstants.ts';
import { TCmsField, TCmsFlow, TCmsStep } from '../models/flow.ts';

const LEGAL_CONSENT_BLOCK = 'legal_consent';

const isDebugEnvironment = () =>
  REACT_APP_ENVIRONMENT === ENVIRONMENTS.DEV || REACT_APP_ENVIRONMENT === ENVIRONMENTS.TEST;

type TBlockDefinition = Omit<Partial<TCmsField>, 'fields'>;

const definitionOf = (block: TPayloadBlock): TBlockDefinition | undefined => {
  if (block.blockType !== LEGAL_CONSENT_BLOCK) {
    return block;
  }

  return typeof block.consent === 'object' && block.consent !== null ? block.consent : undefined;
};

const normalizeBlock = (block: TPayloadBlock): TCmsField | undefined => {
  const definition = definitionOf(block);

  if (!definition?.fieldType) {
    if (isDebugEnvironment()) {
      console.info('Unresolved CMS block, skipping:', {
        blockType: block.blockType,
        name:      block.name,
      });
    }

    return undefined;
  }

  const fields = block.fields?.map(normalizeBlock).filter((field): field is TCmsField => !!field);

  return {
    ...definition,
    fieldType: definition.fieldType as FieldType,
    ...(fields ? { fields } : {}),
  };
};

const normalizeStep = (step: NonNullable<TPayloadFlow['steps']>[number]): TCmsStep => ({
  ...step,
  fields:          step.fields?.map(normalizeBlock).filter((field): field is TCmsField => !!field) ?? [],
  primaryButton:   step.primaryButton ?? [],
  secondaryButton: step.secondaryButton ?? [],
});

export const normalizeFlow = (flow: TPayloadFlow): TCmsFlow => ({
  name:  flow.name,
  steps: (flow.steps ?? []).map(normalizeStep),
});
